<template>
    <!-- 浮层 搜索记录、为您推荐 -->
    <div class="layer_float">
        <!-- 搜索记录 -->
        <div class="search_record" v-if="this.searchRecordList && this.searchRecordList.length!=0">
            <p class="module_title">历史记录 <span @click="deleteRecords"><img src="../../../assets/images/icon/delete.png" alt=""></span></p>
            <div class="record_list">
                <span :key="index" v-for="(item,index) in searchRecordList" @click="searchChange(item)">{{item}}</span>
            </div>
        </div>
        <!-- dialog -->
        <dia-log :dialogParams="dialogRecordParams" @clearRecordList="clearRecordList"></dia-log>
    </div>
</template>

<style lang="less" scoped>
.layer_float{
    width: 100%;
    background: @expertFontColor255;
    // 搜索记录、为您推荐
    .search_record{
        padding: 0 12px 16px;
        .module_title{
            font-size:@indexFontSize16;
            font-weight: bolder;
            color: @expertFontColor51;
            margin-bottom: 6px;
            padding: 12px 12px 7px 0;
            span{
                font-size:@indexFontSize14;
                float: right;
                img{
                    width: 16px;
                    margin-top: 3px;
                }
            }
        }
        .record_list{
            font-size:@indexFontSize14;
            font-weight: 400;
            color: @expertFontColor51;
            span{
                max-width: 320px;
                display: inline-block;
                padding: 5px 12px;
                background:@expertBorderColor242;
                border-radius:15px;
                margin: 6px 0;
                margin-right: 12px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>

<script>
import { uniqueArr } from "@/assets/js/common.js";
import diaLog from "@//components/contents/dialog.vue";//dialog
export default {
    name:"layerFloat",
    props:["recordList"],
    components:{
        diaLog
    },
    data(){
        return{
            searchRecordList:[],
            dialogRecordParams:{
                flag:false
            }
        }
    },
    watch: {
        recordList(val){
            this.searchRecordList.unshift(val);
            this.searchRecordList = this.uniqueArr(this.searchRecordList);
            if(this.searchRecordList.length>6){
                this.searchRecordList = this.searchRecordList.slice(0,6);
            }
            localStorage.setItem("expertSearchList",this.searchRecordList.join(","));
            if(this.$route.name=="expertOnlineList"){
                this.$router.push({ path: "/expertOnline/search/"+this.recordList});
            }
        }
    },
    mounted(){
        if(!$(".vanSearch")[0]) return false;
        $(".layer_float").css("height",($("body").height()-$(".vanSearch")[0].clientHeight)+"px");
        $(window).resize(function() {
            $(".layer_float").css("height",($("body").height()-$(".vanSearch")[0].clientHeight)+"px");
        });
        // 获取本地搜索记录
        if (localStorage.getItem("expertSearchList") && localStorage.getItem("expertSearchList") !== "") {
            this.searchRecordList = localStorage.getItem("expertSearchList").split(",");
        }
    },
    methods:{
        uniqueArr,
        // 删除本地历史记录
        deleteRecords: function(){
            this.dialogRecordParams = {
                flag:true,
                message:"是否确认清空所有搜索记录?",
                cancelHtml:"否",
                confirmHtml:"是",
                emitFn:true,
                confirm:function(){
                    this.searchRecordList=[];
                    localStorage.setItem("expertSearchList","");
                }
            }
        },
        clearRecordList:function(){
            this.searchRecordList=[];
            localStorage.setItem("expertSearchList","");
        },
        // 搜索
        searchChange:function (val){
            this.searchText = val;
            if( this.$route.name == "expertOnlineList" ){
                this.$router.push("/expertOnline/search/"+val);
            }else{
                this.$emit("searchTextChange",val);
            }
        }
    }
}
</script>
